import { ARTIFACT_RENDERERS, ArtifactRendererMap, BaseArtifactRenderer, ELlmResponseType, ILlmPayload } from '@adaptiva/ai/common';
import { inject, Pipe, PipeTransform, Type } from '@angular/core';

@Pipe({
	name: 'adaLlmArtifactRendererType'
})
export class LlmArtifactRendererTypePipe implements PipeTransform {

	protected readonly rendererTypes: ArtifactRendererMap = inject(ARTIFACT_RENDERERS);

	public transform(_responseType: ELlmResponseType): Type<BaseArtifactRenderer<ILlmPayload>> {
		const _renderer: Type<BaseArtifactRenderer<ILlmPayload>> = this.rendererTypes.get(_responseType);

		if (_renderer == null)
			throw new ReferenceError(`No artifact renderer for type "${_responseType}"`);

		return _renderer;
	}

}
